import { NamedDefinitionPage } from './NamedDefinitionPage';

export function VendorGroupsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/vendorgroups"
      listRoute="/vendor-groups"
      title="Distribütör Grubu Yönetimi"
      subtitle="Distribütör grubu kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Grup Kodu"
      descriptionLabel="Açıklama"
      newLabel="Yeni Distribütör Grubu"
    />
  );
}
